import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { Trans, useTranslation } from 'react-i18next';

export default function About() {
  const { t } = useTranslation('common');
  return (
    <Row>
      <Col>
        <section className="module-title-section">
          <h1>{t('pages.about.title')}</h1>
        </section>
        <section className="section">
          <Trans i18nKey="pages.about.section.editor" ns="common">
            <h2>Herausgeberin</h2>
            <p>
              AGRIDEA
              <br />
              Jordils 1
              <br />
              CP 1080
              <br />
              CH-1001 Lausanne
            </p>
          </Trans>
          <p>
            <a href="mailto:info@sct.swissgolf.ch">info@sct.swissgolf.ch</a>
            <br />
            <a href="https://www.agridea.ch" target="_blank" rel="noreferrer">agridea.ch</a>
          </p>
        </section>
        <section className="section">
          <Trans i18nKey="pages.about.section.mandat" ns="common">
            <h2>Auftraggeber</h2>
            <p>
              Swiss Golf
              <br />
              Thunstrasse 110
              <br />
              3006 Bern
              <br />
              +41 31 358 08 00
            </p>
          </Trans>
          <p>
            <a href="mailto:info@swissgolf.ch">info@swissgolf.ch</a>
          </p>
        </section>
      </Col>
    </Row>
  );
}
